import { defineComponent as _defineComponent } from 'vue'
import { useFileDialog } from '@vueuse/core';
import { useUserStore } from '@/helpers/composables/useStores';

import { computed, ref, watch } from 'vue';
import { faPencil } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputAvatar',
  props: {
    fileSizeLimit: { default: 5 }
  },
  emits: ["fileUpdated", "open"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'fileUpdated', base64: string): void;
	(e: 'open'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { fileSizeLimit: number };





const { profileInfo, userInfo } = useUserStore();
const defaultProfileIcon = computed(() =>
	(profileInfo.value.firstName || userInfo.value.email).charAt(0).toUpperCase()
);

const base64Image = ref<string | null>(null);

const { files, open } = useFileDialog({
	multiple: false,
	accept: 'image/jpeg, image/jpg, image/png, image/avif, image/webp',
	reset: true,
});

function openFileSelector() {
	open();
	emit('open');
}

const filePreviewUrl = computed(() => {
	if (files.value?.[0]) {
		return URL.createObjectURL(files.value[0]);
	}

	if (profileInfo.value?.avatarUrl) {
		return profileInfo.value?.avatarUrl;
	}

	return '';
});

const fileAllowed = computed(() => {
	if (files.value == null) return { error: 'no files', valid: true };
	if (files.value.length === 0) return { error: null, valid: true };
	if (files.value.length > 1) return { error: 'max 1 file', valid: false };

	const file = files.value.item(0);
	if (file == null) return { error: 'file error', valid: false };
	if (file.name == null) return { error: 'no filename', valid: false };

	const fileSize = Number((file.size / 1024 / 1024).toFixed(4));
	if (Number.isNaN(fileSize)) return { error: 'file size', valid: false };
	if (fileSize > props.fileSizeLimit) return { error: `file larger than ${props.fileSizeLimit}mb`, valid: false };

	return { error: null, valid: true };
});

const encodeImageFileAsURL = (file: File): Promise<string | ArrayBuffer | null> => {
	return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
		if (!file) {
			reject('No file provided');
			return;
		}

		const reader: FileReader = new FileReader();
		reader.onloadend = () => resolve(reader.result);
		reader.onerror = () => reject('Error reading file');
		reader.readAsDataURL(file);
	});
};

watch(files, async newFiles => {
	if (newFiles && newFiles[0]) {
		try {
			const encodedImage = (await encodeImageFileAsURL(newFiles[0])) as string;
			base64Image.value = encodedImage.substring(encodedImage.indexOf(',') + 1);
			emit('fileUpdated', base64Image.value);
		} catch (error) {
			console.error(error);
			base64Image.value = null;
		}
	} else {
		base64Image.value = null;
	}
});

return { __sfc: true,props, emit, profileInfo, userInfo, defaultProfileIcon, base64Image, files, open, openFileSelector, filePreviewUrl, fileAllowed, encodeImageFileAsURL, faPencil }
}

})